module.exports = __webpack_public_path__ + "static/img/case8.e8c19894.png";